// extracted by mini-css-extract-plugin
export default {"error-wrap":"ErrorPage_error-wrap__R46kD"};